import { ref } from '@nuxtjs/composition-api';

const DPD_LOCALE = 'en';
const UNSUPPORTED_DPD_COUNTRIES_ISO = ['bg', 'it', 'lu', 'ro', 'se', 'ch'];

const unsupportedDpdCountriesSet = new Set(UNSUPPORTED_DPD_COUNTRIES_ISO);

const useDPD = () => {
  const dpdBaseUrl = 'https://pickup.dpd.cz/api';

  const getData = async (endpoint: string, options: any) => {
    const stringParams = options?.params
      ? `?${new URLSearchParams(options.params).toString()}`
      : '';
    const fullUrl = `${dpdBaseUrl}${endpoint}${stringParams}`;

    const response = await fetch(fullUrl);
    const json = { data: await response.json() };
    return json;
  };

  const dpdCountries = ref([]);
  const isDpdCountriesLoading = ref(false);

  const dpdCities = ref([]);
  const isDpdCitiesLoading = ref(false);

  const dpdAddresses = ref([]);
  const isDpdAddressesLoading = ref(false);

  const getDpdCountries = async () => {
    isDpdCountriesLoading.value = true;
    const { data } = await getData('/get-countries', {
      params: {
        lang: DPD_LOCALE,
      },
    });
    isDpdCountriesLoading.value = false;
    dpdCountries.value = data.data.items.filter(
      (item: any) => !unsupportedDpdCountriesSet.has(item.iso),
    );

    return data;
  };

  const getDpdCities = async (country: number) => {
    isDpdCitiesLoading.value = true;
    const { data } = await getData('/get-all', {
      params: {
        lang: DPD_LOCALE,
        country,
      },
    });
    isDpdCitiesLoading.value = false;
    dpdCities.value = data.data.items;

    return data;
  };

  // не используется
  const getDpdAdressesByCity = async (city: string) => {
    isDpdAddressesLoading.value = true;
    const { data } = await getData('/get-parcel-shops-by-address', {
      params: {
        lang: DPD_LOCALE,
        limit: 20, // Max - 100, но слишком большой массив получается
        address: city,
      },
    });
    isDpdAddressesLoading.value = false;
    dpdAddresses.value = data.id !== 1001 ? data.data.items : [];

    return data;
  };
  return {
    dpdCountries,
    dpdCities,
    dpdAddresses,
    getDpdCountries,
    getDpdCities,
    getDpdAdressesByCity,
    isDpdCountriesLoading,
    isDpdCitiesLoading,
    isDpdAddressesLoading,
  };
};

export default useDPD;
